import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";

export default function ThreadItem({ thread }) {
    const { organizationId, chatId } = useParams();

    const [lastMessageText, setLastMessageText] = useState("Немає повідомлень");
    const [lastMessageTime, setLastMessageTime] = useState();
    const [unreadMessages, setUnreadMessages] = useState(0);

    useEffect(() => {
        const truncateMessage = (text, maxLength = 30) => {
            if (!text) return "Немає повідомлень";
            return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
        };
    
        const getUnreadCount = (lastMessages) => {
            if (!Array.isArray(lastMessages) || lastMessages.length === 0)
                return 0; // check null ro empty array
    
            let unreadCount = 0;
            for (let i = 0; i < lastMessages.length; i++) {
                if (lastMessages[i].sender === "user") {
                    unreadCount++;
                } else if (lastMessages[i].isSent === false) {
                    continue;
                } else {
                    break;
                }
            }
    
            return unreadCount;
        };

        const lastMessageArray = Array.isArray(thread.last_message) ? thread.last_message : [];
        const unreadMessages = getUnreadCount(lastMessageArray);
        const lastMessage = lastMessageArray.length > 0 ? truncateMessage(lastMessageArray[0].text) : "Немає повідомлень";

        setLastMessageText(lastMessage);
        setLastMessageTime(lastMessageArray.length > 0 ? lastMessageArray[0].timestamp : thread.timestamp);
        setUnreadMessages(unreadMessages);
    }, [thread]);

    // formatPhoneNumber function for phones of any country:
        const formatPhoneNumber = (phone) => {
            if (!phone) return "";
            const digits = phone.replace(/\D/g, "");
            if (digits.length < 6) return phone; // too short to format

            let countryCode = "";
            let rest = digits;

            if (digits.startsWith("0")) {
                // Local number without country code
                return phone;
            } else if (digits.startsWith("00")) {
                // International prefix with 00
                countryCode = "+" + digits.slice(2, 4); 
                rest = digits.slice(4);
            } else if (digits.startsWith("+")) {
                // Already in + format (rare in raw digits form)
                return phone;
            } else if (digits.length > 10) {
                // Assume first 1–3 digits are country code
                countryCode = "+" + digits.slice(0, digits.length - 10);
                rest = digits.slice(digits.length - 10);
            }

            // Format rest as (XXX) XXX XX XX or similar depending on length
            if (rest.length === 10) {
                return `${countryCode} (${rest.slice(0, 3)}) ${rest.slice(3, 6)} ${rest.slice(6, 8)} ${rest.slice(8)}`;
            } else if (rest.length === 9) {
                return `${countryCode} (${rest.slice(0, 2)}) ${rest.slice(2, 5)} ${rest.slice(5, 7)} ${rest.slice(7)}`;
            }

            return `${countryCode} ${rest}`;
        };

    const formatTimestamp = (timestamp) => {
        const now = new Date();
        const msgDate = new Date(timestamp);
        if (isNaN(msgDate.getTime())) return "Invalid date";

        const isToday = now.toDateString() === msgDate.toDateString();
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        const isYesterday = yesterday.toDateString() === msgDate.toDateString();
        const hours = String(msgDate.getHours()).padStart(2, "0");
        const minutes = String(msgDate.getMinutes()).padStart(2, "0");

        if (isToday) {
            return `${hours}:${minutes}`;
        } else if (isYesterday) {
            return `Yesterday ${hours}:${minutes}`;
        } else {
            const month = msgDate.toLocaleString("default", { month: "short" });
            const day = msgDate.getDate();
            return `${month} ${day}, ${hours}:${minutes}`;
        }
    };

    return (
        <>
            <div key={thread.id} className={`chat-item ${thread.id === chatId ? "active" : ""}`}>
                <Link
                    to={`/organizations/${organizationId}/chats/${thread.id}`}
                    className="d-flex chat-item-link flex-row gap"
                >
                    <div className="image-icon">
                        <div
                            style={thread.starterImg ? { backgroundImage: `url(${thread.starterImg})` } : {}}
                            className={`starter-image ${thread.starterImg ? "" : "user-logo"}`}
                        />
                        <div className={`source-icon ${thread.channel?.channel_type === "IFRAME" ? "site" : thread.channel?.channel_type?.toLowerCase()}`}></div>
                    </div>
                    <div className="name-message">
                        <div className="starter-name">{thread.name || "Без Імені"}</div>
                        <div className="phone-nuber">{formatPhoneNumber(thread.phone)}</div>
                        <div className="last-message">{lastMessageText}</div>
                    </div>
                    <div className="last-message-time">
                        {lastMessageTime && (formatTimestamp(lastMessageTime))}
                    </div>
                    {unreadMessages > 0 && (
                        <div className="unread-messages">{unreadMessages}</div>
                    )}
                </Link>
            </div>
        </>
    );
}